import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { mockDeviceStats } from "@/mocks/statistics";

interface Props {
  deviceStats?: { device: string; count: number; percent: number }[];
}

const defaultColors = ["#10b981", "#34d399", "#6ee7b7", "#a7f3d0", "#d1fae5"];

export default function DeviceBreakdown({ deviceStats }: Props) {
  const data = deviceStats && deviceStats.length > 0
    ? deviceStats.map((d, i) => ({ device: d.device, percent: d.percent, color: defaultColors[i % defaultColors.length] }))
    : mockDeviceStats;

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5">
      <h3 className="font-bold text-gray-900 mb-4 text-sm">Cihaz Dağılımı</h3>
      <div className="flex items-center gap-4">
        <ResponsiveContainer width={100} height={100}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={28}
              outerRadius={45}
              dataKey="percent"
              strokeWidth={0}
            >
              {data.map((entry, index) => (
                <Cell key={index} fill={(entry as { color?: string }).color || defaultColors[index % defaultColors.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(val) => [`${val}%`, ""]} contentStyle={{ borderRadius: "8px", fontSize: "11px" }} />
          </PieChart>
        </ResponsiveContainer>
        <div className="flex-1 space-y-2">
          {data.map((item, idx) => (
            <div key={item.device} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: (item as { color?: string }).color || defaultColors[idx % defaultColors.length] }}></div>
                <span className="text-xs text-gray-600">{item.device}</span>
              </div>
              <span className="text-xs font-bold text-gray-900">{item.percent}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}